import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";

import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { CustomAlert } from "@shared/CustomAlert/CustomAlert";

import { WorkspaceConfigurationPanel } from "./components/WorkspaceConfigurationPanel/WorkspaceConfigurationPanel";
import { useWorkspacePageAccess } from "./hooks/useWorkspacePageAccess";
import { WorkspaceSubPageLayout } from "./WorkspaceSubPageLayout";

function WorkspaceConfigurationPage() {
    const { t } = useTranslation(["pages"]);
    const { canAccessConfigurationTab } = useWorkspacePageAccess();

    return (
        <WorkspaceSubPageLayout>
            {canAccessConfigurationTab ? (
                <WorkspaceConfigurationPanel />
            ) : (
                <CustomAlert severity="info" title={t("pages:workspacePage.restricted.configuration.title")}>
                    {t("pages:workspacePage.restricted.configuration.description")}
                </CustomAlert>
            )}
        </WorkspaceSubPageLayout>
    );
}

export default withMetaDescription(WorkspaceConfigurationPage, {
    title: i18next.t("pages:workspacePage.pages.configuration.metaTitle"),
    description: i18next.t("pages:workspacePage.pages.configuration.metaDescription"),
});
